module.exports = __webpack_public_path__ + "img/newPeopleVipTitle.36fd3e60.jpg";